import { render, staticRenderFns } from "./Dater.vue?vue&type=template&id=5b92d7a4&"
import script from "./Dater.vue?vue&type=script&lang=js&"
export * from "./Dater.vue?vue&type=script&lang=js&"
import style0 from "./Dater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import TouchSwipe from 'quasar/src/directives/TouchSwipe.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QBtnToggle});qInstall(component, 'directives', {TouchSwipe});
